// 用户中心-用户出行人操作
const UserContactRouterMap = [
  // 用户出行人
  {
    path: '/user/contact',
    component: Contact => (require(['@/views/user/contact'], Contact))
  },
  // 用户出行人新增编辑
  {
    path: '/user/contact-edit',
    component: ContactEdit => (require(['@/views/user/contactEdit'], ContactEdit))
  }
]

export default UserContactRouterMap



// WEBPACK FOOTER //
// ./src/router/modules/user/contact.js